// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1g6BX","title":"ClientInsurance_title__1qoH_","itemText":"ClientInsurance_itemText__2wCg2"};